import React, { useEffect, useState } from 'react';
import Popup from 'reactjs-popup';
import useFordRidesContext from '../hooks/use-ford-rides-context';
import './rides-modal.scss';

interface Props {
    openModal?: Function;
    closeModal?: Function;
    children?: React.JSX.Element;
    buttonContainer?: React.JSX.Element;
}

const RidesModal = (props: Props) => {
    const { resolve, reject, isOpen } = useFordRidesContext();
    const [open, setOpen] = useState(false);
    function openModal() {
        setOpen(true);
        return true;
    }

    function closeModal() {
        setOpen(false);
        return false;
    }

    props?.openModal && props.openModal(openModal);
    props?.closeModal && props.closeModal(closeModal);

    useEffect(() => {
        const handleKeydown = (e: KeyboardEvent) => {
            if (resolve && isOpen && e.key === 'Enter') {
                resolve();
            } else if (reject && isOpen && e.key === 'Escape') {
                reject();
            }
        };

        window.addEventListener('keydown', handleKeydown);
        return () => window.removeEventListener('keydown', handleKeydown);
    }, [resolve, reject, isOpen]);

    return (
        <Popup
            modal={true}
            open={open}
            lockScroll={true}
            className="ford-rides-modal"
            closeOnDocumentClick={false}
        >
            {props.children ?? <></>}
            {props.buttonContainer ?? <></>}
        </Popup>
    );
};

export default RidesModal;
